// Adapter for transform version history.
// Plugs into GenericHistoryDrawer to display transform code diffs.

import { useTransformVersions, useRestoreTransformVersion } from "@/hooks/useTransformVersions";
import type { TransformVersion } from "@/types/ontology";
import type { VersionAdapter, DiffContent } from "@/components/history/VersionAdapter";

export interface TransformCurrentState {
  code: string;
}

export const transformVersionAdapter: VersionAdapter<TransformVersion, TransformCurrentState> = {
  useVersions(entityId: string) {
    return useTransformVersions(entityId);
  },

  useRestore() {
    const restore = useRestoreTransformVersion();
    return {
      ...restore,
      mutateAsync: async ({
        entityId,
        version,
        expectedVersion,
        note,
      }: {
        entityId: string;
        version: TransformVersion;
        expectedVersion: number;
        note?: string;
      }) => {
        return restore.mutateAsync({ transformId: entityId, version, expectedVersion, note });
      },
    } as ReturnType<typeof useRestoreTransformVersion>;
  },

  formatVersion(version: TransformVersion, currentState: TransformCurrentState): DiffContent {
    return {
      label: `v${version.version_number}`,
      before: version.code,
      after: currentState.code,
    };
  },
};
